import React, { useState, useEffect } from 'react';
import "./Post.css";
import { Avatar, IconButton } from "@material-ui/core";
import { db } from "./firebase";
import firebase from "firebase";
import { makeStyles } from '@material-ui/core/styles';
import BookmarkBorderOutlinedIcon from '@material-ui/icons/BookmarkBorderOutlined';
import ChatBubbleOutlineTwoToneIcon from '@material-ui/icons/ChatBubbleOutlineTwoTone';
import FavoriteBorderRoundedIcon from '@material-ui/icons/FavoriteBorderRounded';
import SendSharpIcon from '@material-ui/icons/SendSharp';

import { deepOrange, deepPurple } from '@material-ui/core/colors';




function Post({ postId, user, imageUrl, username, caption }) {

    // const [posts, setPosts] = useState([]);
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
        },
        orange: {
            color: theme.palette.getContrastText(deepOrange[500]),
            backgroundColor: deepOrange[500],
        },
        purple: {
            color: theme.palette.getContrastText(deepPurple[500]),
            backgroundColor: deepPurple[500],
        },
    }));
    const classes = useStyles();

    const [comment, setComment] = useState('');
    const [comments, setComments] = useState([]);

    useEffect(() => {
        let unsubscribe;
        if (postId) {
            unsubscribe = db
                .collection("posts")
                .doc(postId)
                .collection("comments")
                .orderBy('timestamp', 'desc')
                .onSnapshot((snapshot) => {
                    setComments(snapshot.docs.map((doc) => doc.data()));
                });
        }
        return () => {
            unsubscribe();
        };
    }, [postId])

    const postComment = (event) => {
        event.preventDefault();
        db.collection("posts").doc(postId).collection("comments").add({
            text: comment,
            username: user.displayName,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
        setComment('');

    }

    return (
        <div className="post">
            {/* Header -> avatar + username */}
            <div className="post__header">
                <Avatar className={classes.purple}
                    alt={username}
                    src="/static/image/avatar/1.jpg"
                // className={classes.blue}
                />
                <h3 className="post__username">{username}</h3>
            </div>

            {/* Image */}
            <img className="post__image" src={imageUrl} alt="" />

            <div className="post__icons">
                <div className="post__iconsLeft">
                    <IconButton>
                        <FavoriteBorderRoundedIcon />
                    </IconButton>
                    <IconButton>
                        <ChatBubbleOutlineTwoToneIcon />
                    </IconButton>
                    <IconButton>
                        <SendSharpIcon />
                    </IconButton>
                </div>
                <div className="post__iconsRight">
                    <IconButton>
                        <BookmarkBorderOutlinedIcon />
                    </IconButton>
                </div>
            </div>

            {/* usernmae + caption */}
            <h4 className="post__text"><strong>@{username}  </strong>{caption}</h4>

            <div className="post__comments">
                {comments.map((comment) => (
                    <p>
                        <strong>{comment.username}</strong> {comment.text}
                    </p>
                ))}
            </div>

            {user && (

                <form className="post__commentBox">
                    <input
                        className="post__input"
                        type="text"
                        placeholder="Add a comment... "
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    // required
                    />
                    <button
                        className="post__button"
                        type="submit"
                        onClick={postComment}
                        disabled={!comment}
                    > Post
                </button>
                </form>
            )
            }
        </div >
    )
}

export default Post
